// Auto-generated from API controllers: endpoint -> allowed HTTP methods
export const ENDPOINT_METHODS = Object.freeze({
  "account/api/v1/auth/login": ["POST"],
  "account/api/v1/auth/logout": ["POST"],
  "account/api/v1/auth/refresh-token": ["POST"],
  "account/createpasswordresetrequest": ["POST"],
  "account/deleteaccount": ["POST"],
  "account/disableaccount": ["POST"],
  "account/followuser": ["POST"],
  "account/getpasswordresetrequest": ["GET"],
  "account/getuseravatar": ["GET"],
  "account/getuserfollowers": ["GET"],
  "account/getuserinfobyemail": ["GET"],
  "account/getusersfollowing": ["GET"],
  "account/impersonation": ["POST"],
  "account/isonline": ["GET"],
  "account/login": ["POST"],
  "account/logout": ["POST"],
  "account/refresh-token": ["POST"],
  "account/register": ["POST"],
  "account/searchusersbyname": ["GET"],
  "account/setforgottenpassword": ["POST"],
  "account/setpassword": ["POST"],
  "account/stop-impersonation": ["POST"],
  "account/unfollowuser": ["POST"],
  "account/uploadprofileimage": ["POST"],
  "account/user": ["GET"],
  "account/userlist": ["GET"],
  "accountprofile/impersonation": ["POST"],
  "accountprofile/logout": ["POST"],
  "accountprofile/refresh-token": ["POST"],
  "accountprofile/setcolor": ["POST"],
  "accountprofile/setname": ["POST"],
  "accountprofile/setpassword": ["POST"],
  "accountprofile/stop-impersonation": ["POST"],
  "accountprofile/togglehidewelcome": ["POST"],
  "accountprofile/toggleprivacypolicy": ["POST"],
  "accountprofile/uploadprofileimage": ["POST"],
  "accountprofile/user": ["GET"],
  "accountprofile/usergroups": ["GET"],
  "accountprofile/userinfo": ["GET"],
  "accountprofile/userprofileimage": ["GET"],
  "admin/getusers": ["GET"],
  "blog/addcontent": ["POST"],
  "blog/createblog": ["POST"],
  "blog/createblogchannel": ["POST"],
  "blog/createblogtemplate": ["POST"],
  "blog/createbodyrow": ["POST"],
  "blog/deleteblog": ["POST"],
  "blog/deleteblogchannel": ["POST"],
  "blog/deleteblogtemplate": ["POST"],
  "blog/deletecontent": ["POST"],
  "blog/deleterow": ["POST"],
  "blog/editblog": ["POST"],
  "blog/editblogchannel": ["POST"],
  "blog/editblogtemplate": ["POST"],
  "blog/edittextcontent": ["POST"],
  "blog/getblog": ["GET"],
  "blog/getblogchannel": ["GET"],
  "blog/getblogtemplates": ["GET"],
  "blog/getuserblogchannels": ["GET"],
  "blog/getuserblogs": ["GET"],
  "blog/movebodyrow": ["POST"],
  "blog/movecontent": ["POST"],
  "blog/setchanneltemplate": ["POST"],
  "blog/subscribe": ["POST"],
  "blog/unsubscribe": ["POST"],
  "blog/updateauthor": ["POST"],
  "blog/updateauthorphotoid": ["POST"],
  "blog/updatecontentphotoid": ["POST"],
  "blog/updatecoverphotoid": ["POST"],
  "blog/updateheader": ["POST"],
  "blog/updatephotoid": ["POST"],
  "blog/updaterowcolcount": ["POST"],
  "blog/updatestatus": ["POST"],
  "business/createadminuser": ["POST"],
  "business/createbusiness": ["POST"],
  "business/createclient": ["POST"],
  "business/createclientifnotexists": ["POST"],
  "business/createclienttype": ["POST"],
  "business/createclientuser": ["POST"],
  "business/deactivatebusiness": ["POST"],
  "business/deleteadminuser": ["POST"],
  "business/deletebusiness": ["POST"],
  "business/deleteclient": ["POST"],
  "business/deleteclienttype": ["POST"],
  "business/deleteclientuser": ["POST"],
  "business/editadminuser": ["POST"],
  "business/editbusiness": ["POST"],
  "business/editclient": ["POST"],
  "business/editclienttype": ["POST"],
  "business/editclientuser": ["POST"],
  "business/getadminusers": ["GET"],
  "business/getallbusinesses": ["GET"],
  "business/getallclientdocuments": ["GET"],
  "business/getbusiness": ["GET"],
  "business/getbusinessesbyadminuser": ["GET"],
  "business/getbusinessesbylocation": ["GET"],
  "business/getbusinessesbytype": ["GET"],
  "business/getbusinessesbyzip": ["GET"],
  "business/getclient": ["GET"],
  "business/getclientdocuments": ["GET"],
  "business/getclientdocumentsbystatus": ["GET"],
  "business/getclientidbyaltid": ["GET"],
  "business/getclients": ["GET"],
  "business/getclientsbytype": ["GET"],
  "business/getclientswithdocswithstatus": ["GET"],
  "business/getclientuserdata": ["GET"],
  "business/getclientusers": ["GET"],
  "business/getuseraffiliations": ["GET"],
  "business/getuserbusinesses": ["GET"],
  "business/isadminuser": ["GET"],
  "business/reactivatebusiness": ["POST"],
  "business/updateadminuserstatus": ["POST"],
  "business/updateclientuserstatus": ["POST"],
  "calendar/createitem": ["POST"],
  "calendar/deleteitem": ["POST"],
  "calendar/edititemdate": ["POST"],
  "calendar/edititemprops": ["POST"],
  "calendar/getdaydetails": ["GET"],
  "calendar/getdays": ["GET"],
  "calendar/getfamilycalendaritems": ["GET"],
  "calendar/getmessageuser": ["GET"],
  "calendar/getusercalendaritems": ["GET"],
  "comments/addcomment": ["POST"],
  "comments/commentcount": ["GET"],
  "comments/deletecomment": ["POST"],
  "comments/editcomment": ["POST"],
  "comments/getchildcomments": ["GET"],
  "comments/getcomments": ["GET"],
  "comments/getmycomments": ["GET"],
  "commentsv1/{commentId}": ["DELETE", "PUT"],
  "constants/addtexttag": ["POST"],
  "constants/getverbiage": ["GET"],
  "document/addedoc": ["POST"],
  "document/addevent": ["POST"],
  "document/addnote": ["POST"],
  "document/addpage": ["POST"],
  "document/createdocument": ["POST"],
  "document/createfolder": ["POST"],
  "document/createfolderifnotexists": ["POST"],
  "document/deletedocument": ["POST"],
  "document/deleteedoc": ["POST"],
  "document/deletefolder": ["POST"],
  "document/deletepage": ["POST"],
  "document/downloadpdf": ["GET"],
  "document/duplicatedocument": ["POST"],
  "document/editdocument": ["POST"],
  "document/editfolder": ["POST"],
  "document/getalldocuments": ["GET"],
  "document/getdocstomigrate": ["GET"],
  "document/getdocument": ["GET"],
  "document/getdocumenthistory": ["GET"],
  "document/getdocumentinfo": ["GET"],
  "document/getdocuments": ["GET"],
  "document/getdocumentsbystatus": ["GET"],
  "document/getfolder": ["GET"],
  "document/getfolders": ["GET"],
  "document/getuserfolders": ["GET"],
  "document/hidesharedcontent": ["POST"],
  "document/migratedoc": ["POST"],
  "document/movedocument": ["POST"],
  "document/moveepage": ["POST"],
  "document/setdocstatus": ["POST"],
  "document/sharecontent": ["POST"],
  "document/unhidesharedcontent": ["POST"],
  "document/unsharecontent": ["POST"],
  "email/sendemail": ["POST"],
  "email/sendnotification": ["POST"],
  "entity/createentity": ["POST"],
  "entity/createentityfield": ["POST"],
  "entity/createfieldinstance": ["POST"],
  "entity/createinstance": ["POST"],
  "entity/deleteentity": ["POST"],
  "entity/deleteentityfield": ["POST"],
  "entity/deletefieldinstance": ["POST"],
  "entity/deleteinstance": ["POST"],
  "entity/editentity": ["POST"],
  "entity/editentityfield": ["POST"],
  "entity/editfieldinstance": ["POST"],
  "entity/getdefaultentity": ["POST"],
  "entity/getentitydefinition": ["GET"],
  "entity/getinstancesbyparent": ["GET"],
  "entity/getuserentitylist": ["GET"],
  "entity/getuserinstancesbyentity": ["GET"],
  "entity/removedefaultentity": ["POST"],
  "entity/searchinstance": ["POST"],
  "entity/setdefaultentity": ["POST"],
  "entity/updateentityfieldindex": ["POST"],
  "event/addattendee": ["POST"],
  "event/addcontent": ["POST"],
  "event/addcoverphoto": ["POST"],
  "event/addschedule": ["POST"],
  "event/addscheduleitem": ["POST"],
  "event/createbodyrow": ["POST"],
  "event/createevent": ["POST"],
  "event/deletecontent": ["POST"],
  "event/deleteevent": ["POST"],
  "event/deleterow": ["POST"],
  "event/editevent": ["POST"],
  "event/editschedule": ["POST"],
  "event/editscheduleitem": ["POST"],
  "event/edittextcontent": ["POST"],
  "event/getattendees": ["GET"],
  "event/getevent": ["GET"],
  "event/geteventsiattended": ["GET"],
  "event/geteventsimattending": ["GET"],
  "event/getmyevents": ["GET"],
  "event/getmypastevents": ["GET"],
  "event/movebodyrow": ["POST"],
  "event/movecontent": ["POST"],
  "event/removeattendee": ["POST"],
  "event/removeschedule": ["POST"],
  "event/removescheduleitem": ["POST"],
  "event/search": ["GET"],
  "event/updatecontentphotoid": ["POST"],
  "event/updaterowcolcount": ["POST"],
  "family/activate": ["POST"],
  "family/activatefamilymember": ["POST"],
  "family/createfamily": ["POST"],
  "family/createfamilymember": ["POST"],
  "family/deactivate": ["POST"],
  "family/deactivatefamilymember": ["POST"],
  "family/delete": ["POST"],
  "family/editfamily": ["POST"],
  "family/editfamilymember": ["POST"],
  "family/getallmyfamilies": ["GET"],
  "family/getallmyownedfamilies": ["GET"],
  "family/getfamily": ["GET"],
  "family/getfamilyinvitations": ["GET"],
  "family/getfamilymember": ["GET"],
  "family/getfamilymembers": ["GET"],
  "family/getfamilywithmembers": ["GET"],
  "family/getmyprimaryfamily": ["GET"],
  "family/removefamilymember": ["POST"],
  "family/setmembercolor": ["POST"],
  "family/setmembernickname": ["POST"],
  "family/setprimaryfamily": ["POST"],
  "family/updatephoto": ["POST"],
  "family/updatesiteoption": ["POST"],
  "link/createfolder": ["POST"],
  "link/createfolderifnotexists": ["POST"],
  "link/createlink": ["POST"],
  "link/deletefolder": ["POST"],
  "link/deletelink": ["POST"],
  "link/editfolder": ["POST"],
  "link/editlink": ["POST"],
  "link/getalllinks": ["GET"],
  "link/getfolders": ["GET"],
  "link/getlinks": ["GET"],
  "link/getuserfolders": ["GET"],
  "link/hidesharedcontent": ["POST"],
  "link/movelink": ["POST"],
  "link/sharecontent": ["POST"],
  "link/unhidesharedcontent": ["POST"],
  "link/unsharecontent": ["POST"],
  "list/checkitem": ["POST"],
  "list/createlist": ["POST"],
  "list/deletelist": ["POST"],
  "list/deletelistitem": ["POST"],
  "list/duplicatelist": ["POST"],
  "list/editlist": ["POST"],
  "list/editlistitem": ["POST"],
  "list/getalllists": ["GET"],
  "list/getlist": ["GET"],
  "list/getlists": ["GET"],
  "list/hidesharedcontent": ["POST"],
  "list/movelistitem": ["POST"],
  "list/newlistitem": ["POST"],
  "list/sharecontent": ["POST"],
  "list/uncheckitem": ["POST"],
  "list/unhidesharedcontent": ["POST"],
  "list/unsharecontent": ["POST"],
  "market/additemmedia": ["POST"],
  "market/createitem": ["POST"],
  "market/createstore": ["POST"],
  "market/deleteitem": ["POST"],
  "market/edititem": ["POST"],
  "market/edititemmedia": ["POST"],
  "market/editstore": ["POST"],
  "market/getitem": ["GET"],
  "market/getstore": ["GET"],
  "market/moveitemmedia": ["POST"],
  "market/removeitemmedia": ["POST"],
  "market/setitemattribute": ["POST"],
  "market/setlongdesc": ["POST"],
  "market/setprimaryitemphoto": ["POST"],
  "mentions/addmention": ["POST"],
  "mentions/getmention": ["GET"],
  "mentions/getmentionsbyuser": ["GET"],
  "mentions/removemention": ["POST"],
  "messenger/addthreaduser": ["POST"],
  "messenger/addthreadusers": ["POST"],
  "messenger/deletemessage": ["POST"],
  "messenger/editmessage": ["POST"],
  "messenger/finishmessage": ["POST"],
  "messenger/getmessage": ["GET"],
  "messenger/getnewmessages": ["GET"],
  "messenger/getorcreategroupthread": ["GET"],
  "messenger/getorcreateuserthread": ["GET"],
  "messenger/getthread": ["GET"],
  "messenger/getuserownedthreads": ["GET"],
  "messenger/getuserthreads": ["GET"],
  "messenger/postmessage": ["POST"],
  "messenger/reactivatethread": ["POST"],
  "messenger/removethread": ["POST"],
  "messenger/removethreaduser": ["POST"],
  "messenger/startmessage": ["POST"],
  "messenger/startthread": ["POST"],
  "music/addsongtoalbum": ["POST"],
  "music/addsongtoplaylist": ["POST"],
  "music/createalbum": ["POST"],
  "music/createartist": ["POST"],
  "music/createplaylist": ["POST"],
  "music/createsong": ["POST"],
  "music/deletealbum": ["POST"],
  "music/deleteartist": ["POST"],
  "music/deleteplaylist": ["POST"],
  "music/deletesong": ["POST"],
  "music/editalbum": ["POST"],
  "music/editartist": ["POST"],
  "music/editplaylist": ["POST"],
  "music/editsong": ["POST"],
  "music/getalbum": ["GET"],
  "music/getalbums": ["GET"],
  "music/getartist": ["GET"],
  "music/getartists": ["GET"],
  "music/getgenres": ["GET"],
  "music/getplaylist": ["GET"],
  "music/getplaylists": ["GET"],
  "music/getsong": ["GET"],
  "music/getsongs": ["GET"],
  "music/hidesharedcontent": ["POST"],
  "music/movesonginalbum": ["POST"],
  "music/movesonginplaylist": ["POST"],
  "music/recordplay": ["POST"],
  "music/removesongfromalbum": ["POST"],
  "music/removesongfromplaylist": ["POST"],
  "music/sharecontent": ["POST"],
  "music/unhidesharedcontent": ["POST"],
  "music/unsharecontent": ["POST"],
  "music/updatesongcontent": ["POST"],
  "music/updatesongimage": ["POST"],
  "musicstream": ["GET"],
  "note/createnotebook": ["POST"],
  "note/createobjectnote": ["POST"],
  "note/createusernote": ["POST"],
  "note/deletenote": ["POST"],
  "note/deletenotebook": ["POST"],
  "note/duplicatenote": ["POST"],
  "note/editdailynote": ["POST"],
  "note/editnote": ["POST"],
  "note/editnotebook": ["POST"],
  "note/editnotecontent": ["POST"],
  "note/getallusernotebooks": ["GET"],
  "note/getallusernotes": ["GET"],
  "note/getdailynote": ["GET"],
  "note/getnote": ["GET"],
  "note/getnotebook": ["GET"],
  "note/getobjectnotes": ["GET"],
  "note/hidesharedcontent": ["POST"],
  "note/movenote": ["POST"],
  "note/reordernote": ["POST"],
  "note/search": ["GET"],
  "note/sharecontent": ["POST"],
  "note/unhidesharedcontent": ["POST"],
  "note/unsharecontent": ["POST"],
  "notification/createnotification": ["POST"],
  "notification/getnotifications": ["GET"],
  "notification/sendnotification": ["POST"],
  "notification/updatenotification": ["POST"],
  "org/addmember": ["POST"],
  "org/confirmmember": ["POST"],
  "org/creategroup": ["POST"],
  "org/declinemember": ["POST"],
  "org/deletegroup": ["POST"],
  "org/editgroup": ["POST"],
  "org/getgroupinvitedmembers": ["GET"],
  "org/getgroupmembers": ["GET"],
  "org/getusergroupmodel": ["GET"],
  "org/getusergroups": ["GET"],
  "org/getuserinvitations": ["GET"],
  "org/removeinvitation": ["POST"],
  "org/removemember": ["POST"],
  "photo/createlibrary": ["POST"],
  "photo/deletelibrary": ["POST"],
  "photo/deletephoto": ["POST"],
  "photo/duplicatephoto": ["POST"],
  "photo/editlibrary": ["POST"],
  "photo/editphoto": ["POST"],
  "photo/getallphotos": ["GET"],
  "photo/getchildlibraries": ["GET"],
  "photo/getlibraries": ["GET"],
  "photo/getmobilephoto": ["GET"],
  "photo/getphoto": ["GET"],
  "photo/getphotos": ["GET"],
  "photo/getphotosbyids": ["POST"],
  "photo/getphotothumb": ["GET"],
  "photo/getsitelibrary": ["GET"],
  "photo/hidesharedcontent": ["POST"],
  "photo/movephoto": ["POST"],
  "photo/newphoto": ["POST"],
  "photo/sharecontent": ["POST"],
  "photo/unhidesharedcontent": ["POST"],
  "photo/unsharecontent": ["POST"],
  "photo/updatephoto": ["POST"],
  "posts/addmobilepostcontent": ["POST"],
  "posts/addmobilepostvideocontent": ["POST"],
  "posts/addmobilepostvideocontentf": ["POST"],
  "posts/addpostcontent": ["POST"],
  "posts/addsource": ["POST"],
  "posts/createblogpost": ["POST"],
  "posts/createeventpost": ["POST"],
  "posts/createmarketpost": ["POST"],
  "posts/createmobilephotopost": ["POST"],
  "posts/createpdfdocumentpost": ["POST"],
  "posts/createphotopost": ["POST"],
  "posts/createpost": ["POST"],
  "posts/createsongpost": ["POST"],
  "posts/createvideopost": ["POST"],
  "posts/deletepost": ["POST"],
  "posts/deletesource": ["POST"],
  "posts/editpost": ["POST"],
  "posts/editposttextcontent": ["POST"],
  "posts/editsource": ["POST"],
  "posts/getmobilepost": ["GET"],
  "posts/getmobileposts": ["GET"],
  "posts/getmobilethoughts": ["GET"],
  "posts/getnewposts": ["GET"],
  "posts/getpost": ["GET"],
  "posts/getpostcontent": ["GET"],
  "posts/getposts": ["GET"],
  "posts/getpostsbyidrange": ["POST"],
  "posts/getpostsbyuser": ["GET"],
  "posts/getsavedpostids": ["GET"],
  "posts/getuserpostedphotoids": ["GET"],
  "posts/repost": ["POST"],
  "posts/savepost": ["POST"],
  "posts/unsavepost": ["POST"],
  "postsv1/{postId}": ["GET"],
  "postsv1/{postId}/comments": ["GET", "POST"],
  "profile/addaddress": ["POST"],
  "profile/addbadhabit": ["POST"],
  "profile/addbucketlistitem": ["POST"],
  "profile/addeducation": ["POST"],
  "profile/addemail": ["POST"],
  "profile/addemployment": ["POST"],
  "profile/addfamilymember": ["POST"],
  "profile/addfavorite": ["POST"],
  "profile/addinterest": ["POST"],
  "profile/addlifeevent": ["POST"],
  "profile/addliferole": ["POST"],
  "profile/addoccupation": ["POST"],
  "profile/addpersonalgoal": ["POST"],
  "profile/addphone": ["POST"],
  "profile/addstrength": ["POST"],
  "profile/addtaste": ["POST"],
  "profile/addweakness": ["POST"],
  "profile/deleteaddress": ["POST"],
  "profile/deletebadhabit": ["POST"],
  "profile/deletebucketlistitem": ["POST"],
  "profile/deleteeducation": ["POST"],
  "profile/deleteemail": ["POST"],
  "profile/deleteemployment": ["POST"],
  "profile/deletefamilymember": ["POST"],
  "profile/deletefavorite": ["POST"],
  "profile/deleteinterest": ["POST"],
  "profile/deletelifeevent": ["POST"],
  "profile/deleteliferole": ["POST"],
  "profile/deleteoccupation": ["POST"],
  "profile/deletepersonalgoal": ["POST"],
  "profile/deletephone": ["POST"],
  "profile/deletestrength": ["POST"],
  "profile/deletetaste": ["POST"],
  "profile/deleteweakness": ["POST"],
  "profile/editaddress": ["POST"],
  "profile/editbadhabit": ["POST"],
  "profile/editbucketlistitem": ["POST"],
  "profile/editeducation": ["POST"],
  "profile/editemail": ["POST"],
  "profile/editemployment": ["POST"],
  "profile/editfamilymember": ["POST"],
  "profile/editlifeevent": ["POST"],
  "profile/editliferole": ["POST"],
  "profile/editoccupation": ["POST"],
  "profile/editpersonalgoal": ["POST"],
  "profile/editphone": ["POST"],
  "profile/editstrength": ["POST"],
  "profile/editweakness": ["POST"],
  "profile/getfeedpreferences": ["GET"],
  "profile/getfullprofile": ["GET"],
  "profile/getpublicattributes": ["GET"],
  "profile/getsitefullprofile": ["GET"],
  "profile/getsiteoptions": ["GET"],
  "profile/getusersite": ["GET"],
  "profile/removepublic": ["POST"],
  "profile/setfeedpreferences": ["POST"],
  "profile/setimportantdate": ["POST"],
  "profile/setpublic": ["POST"],
  "profile/setsiteoptions": ["POST"],
  "profile/updateheadline": ["POST"],
  "profile/updatetrait": ["POST"],
  "project/addbudgetitem": ["POST"],
  "project/addexpense": ["POST"],
  "project/addtaskresource": ["POST"],
  "project/addteammember": ["POST"],
  "project/assignphase": ["POST"],
  "project/assignproject": ["POST"],
  "project/assigntask": ["POST"],
  "project/copytask": ["POST"],
  "project/createphase": ["POST"],
  "project/createproject": ["POST"],
  "project/createtask": ["POST"],
  "project/createteam": ["POST"],
  "project/deletebudgetitem": ["POST"],
  "project/deleteexpense": ["POST"],
  "project/deletephase": ["POST"],
  "project/deleteproject": ["POST"],
  "project/deletetask": ["POST"],
  "project/deleteteam": ["POST"],
  "project/deleteteammember": ["POST"],
  "project/editbudgetitem": ["POST"],
  "project/editexpense": ["POST"],
  "project/editphase": ["POST"],
  "project/editproject": ["POST"],
  "project/edittask": ["POST"],
  "project/editteam": ["POST"],
  "project/editteammember": ["POST"],
  "project/getbudgetitems": ["GET"],
  "project/getexpenses": ["GET"],
  "project/getmember": ["GET"],
  "project/getmembers": ["GET"],
  "project/getphase": ["GET"],
  "project/getphases": ["GET"],
  "project/getproject": ["GET"],
  "project/getprojects": ["GET"],
  "project/gettask": ["GET"],
  "project/gettasks": ["GET"],
  "project/getteam": ["GET"],
  "project/getteams": ["GET"],
  "project/getuserprojects": ["GET"],
  "project/removetaskresource": ["POST"],
  "project/reorderphase": ["POST"],
  "project/reordertask": ["POST"],
  "project/setprojectphoto": ["POST"],
  "project/setteamphoto": ["POST"],
  "project/splittask": ["POST"],
  "project/updatebudgetitemstatus": ["POST"],
  "project/updateexpensestatus": ["POST"],
  "project/updateprojectbudget": ["POST"],
  "project/updateprojectstatus": ["POST"],
  "project/updatetaskstatus": ["POST"],
  "reactions/addreaction": ["POST"],
  "reactions/deletereaction": ["POST"],
  "reactions/getdetailedreactions": ["GET"],
  "reactions/getmyreactions": ["GET"],
  "reactions/getreactions": ["GET"],
  "reviews/createreview": ["POST"],
  "reviews/deletereview": ["POST"],
  "reviews/deletereviewmedia": ["POST"],
  "reviews/editreview": ["POST"],
  "reviews/getrating": ["GET"],
  "reviews/getreviews": ["GET"],
  "reviews/postreviewmedia": ["POST"],
  "search/search": ["POST"],
  "sites/checksitenameavailability": ["GET"],
  "sites/createsite": ["POST"],
  "sites/getdocumentcontent": ["GET"],
  "sites/getfamilysite": ["GET"],
  "sites/getphotocontent": ["GET"],
  "sites/getsite": ["GET"],
  "sites/getsitemanagement": ["GET"],
  "sites/updateoption": ["POST"],
  "sites/updatepersonaloption": ["POST"],
  "sites/updatephoto": ["POST"],
  "sites/updatestatus": ["POST"],
  "sms": ["GET", "POST"],
  "tags/addtexttag": ["POST"],
  "tags/addusertag": ["POST"],
  "tags/getalltags": ["GET"],
  "tags/getitemswithtexttag": ["GET"],
  "tags/getitemswithusertag": ["GET"],
  "tags/gettexttags": ["GET"],
  "tags/getusertags": ["GET"],
  "tags/removetexttag": ["POST"],
  "tags/removeusertag": ["POST"],
  "task/createtask": ["POST"],
  "task/deletetask": ["POST"],
  "task/duplicatetask": ["POST"],
  "task/edittask": ["POST"],
  "task/getalltasks": ["GET"],
  "task/gettask": ["GET"],
  "task/gettasks": ["GET"],
  "usersmemedia/audio/{id}/content": ["PUT"],
  "usersmemedia/photos": ["POST"],
  "usersmemedia/videos": ["POST"],
  "usersmeposts": ["GET", "POST"],
  "video/createlibrary": ["POST"],
  "video/deletelibrary": ["POST"],
  "video/deleterumblevideo": ["POST"],
  "video/deletevideo": ["POST"],
  "video/editlibrary": ["POST"],
  "video/editrumblevideo": ["POST"],
  "video/getlibraries": ["GET"],
  "video/getlibrary": ["GET"],
  "video/getrumblevideo": ["GET"],
  "video/getvideo": ["GET"],
  "video/movevideo": ["POST"],
  "video/saverumblevideo": ["POST"],
  "video/savevideo": ["POST"],
  "video/savevideob64": ["POST"],
  "video/updatecover": ["POST"],
  "videostream": ["GET"],
  "webpage/addcontactformsubmission": ["POST"],
  "webpage/addcontactnotificationrecipient": ["POST"],
  "webpage/addcontent": ["POST"],
  "webpage/addsection": ["POST"],
  "webpage/addsiteuser": ["POST"],
  "webpage/deletecontent": ["POST"],
  "webpage/disablecontent": ["POST"],
  "webpage/editcontent": ["POST"],
  "webpage/editsection": ["POST"],
  "webpage/enablecontent": ["POST"],
  "webpage/getcontactformdata": ["GET"],
  "webpage/getcontactnotificationrecipients": ["GET"],
  "webpage/getpage": ["GET"],
  "webpage/getpageadmins": ["GET"],
  "webpage/getpageusers": ["GET"],
  "webpage/getpageusertype": ["GET"],
  "webpage/movecontent": ["POST"],
  "webpage/removecontactnotificationrecipient": ["POST"],
  "webpage/removesiteuser": ["POST"],
  "webpage/setcontentphoto": ["POST"],
  "webpage/setusertype": ["POST"],
  "webpage/updatecontactformsubmissionstatus": ["POST"],
});
